module.exports = __webpack_public_path__ + "static/media/Portrait-10203.f73101c6.jpg";